import { useContext, useEffect, useRef } from 'react';
import { OverlayContext } from '../contexts/overlayContext';
import useLanguage from '../hooks/useLanguage';

const ChunkErrorFallback = () => {
  const { presentOverlay } = useContext(OverlayContext);
  const language = useLanguage();

  const presentOverlayRef = useRef(presentOverlay);
  const languageRef = useRef(language);

  useEffect(() => {
    presentOverlayRef.current({
      type: 'ALERT',
      data: {
        title: languageRef.current.get('error'),
        message: languageRef.current.get('failed_loading_data'),
        persistent: true,
        dismissible: false,
        items: [
          {
            title: languageRef.current.get('try_again'),
            onClick: () => window.location.reload(),
          },
        ],
      },
    });
  }, []);

  return null;
};

export default ChunkErrorFallback;
